import {LazyImage} from '@sdox/ui'

import type {XcNwBlock_BlockSeFeatureImagesType_Fragment} from '@sdox/api'

export const BlockSeFeatureImages = ({images}: XcNwBlock_BlockSeFeatureImagesType_Fragment) => (
  <div className={'grid grid-cols-2 sm:grid-cols-4'}>
    {images.map((image) => (
      <div
        key={image.id}
        className={'flex aspect-[4/3] h-full select-none items-center justify-center border-1'}
      >
        <LazyImage
          src={image.thumbnailUrl}
          alt={image.altText ?? ''}
          className={'block'}
          hasBackground={false}
          style={{maxWidth: '50%', maxHeight: '50%'}}
        />
      </div>
    ))}
  </div>
)
